/* SuperProduse.ro Black Friday homepage & policy pages — client behaviour. Config arrives in window.IDT (sections/idt-home.liquid). */
(function () {
  'use strict';
  var CFG = window.IDT || {};
  var TICK_RE = /^(.*?) din (.*?) a cump[aă]rat produsul (acum (\d+) min.*)$/;
  CFG.ticker = (CFG.ticker || []).map(function (t) { return String(t).replace(/^\s*🛒\s*/, '').trim(); }).filter(Boolean);
  var randMins = function () { return 1 + Math.floor(Math.random() * Math.random() * 38); };
  if (!CFG.buyers) {
    var pool = (window.IDT_BUYERS || []).slice();
    for (var pi = pool.length - 1; pi > 0; pi--) { var pj = Math.floor(Math.random() * (pi + 1)); var pt = pool[pi]; pool[pi] = pool[pj]; pool[pj] = pt; }
    CFG.buyers = pool.length
      ? pool.map(function (p) { return { name: p[0], city: p[1] }; })
      : CFG.ticker.map(function (t) { var m = TICK_RE.exec(t); return m ? { name: m[1], city: m[2] } : null; }).filter(Boolean);
  }
  var MOCK = CFG.mock || {};
  var params = new URLSearchParams(location.search);
  var demo = params.get('demo') || '';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  };
  var norm = function (str) {
    return String(str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  };
  var esc = function (str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };

  /* ---------- countdown (evergreen mock, persisted so a reload does not reset it) ---------- */
  var DURATION = ((MOCK.countdownSeconds && MOCK.countdownSeconds > 0 ? MOCK.countdownSeconds : 15480)) * 1000;
  var end = Number(store.get('sp-bf-offer-end')) || 0;
  if (!end || end - Date.now() <= 0 || end - Date.now() > DURATION) {
    end = Date.now() + DURATION;
    store.set('sp-bf-offer-end', String(end));
  }
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  function tick() {
    var timerEls = $$('[data-timer]');
    if (!timerEls.length) return;
    var left = end - Date.now();
    if (left <= 0) { end = Date.now() + DURATION; store.set('sp-bf-offer-end', String(end)); left = DURATION; }
    var s = Math.floor(left / 1000);
    var parts = [pad(Math.floor(s / 3600)), pad(Math.floor((s % 3600) / 60)), pad(s % 60)];
    timerEls.forEach(function (el) {
      if (el.hasAttribute('data-timer-split')) {
        var boxes = el.getElementsByTagName('i');
        if (!boxes.length) el.innerHTML = '<i>00</i><u>:</u><i>00</i><u>:</u><i>00</i>';
        for (var i = 0; i < 3; i++) if (boxes[i] && boxes[i].textContent !== parts[i]) boxes[i].textContent = parts[i];
      } else {
        el.textContent = parts.join(':');
      }
    });
  }
  tick();
  setInterval(tick, 1000);

  /* ---------- delivery dates: Bucharest calendar, working days skip weekends and public holidays ---------- */
  var DAY = 86400000;
  var CUTOFF = 14 * 60;
  var WEEKDAYS = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  var MONTHS = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
  var holidays = '2026-01-01,2026-01-02,2026-01-06,2026-01-07,2026-01-24,2026-04-10,2026-04-12,2026-04-13,2026-05-01,2026-05-31,2026-06-01,2026-08-15,2026-11-30,2026-12-01,2026-12-25,2026-12-26,2027-01-01,2027-01-02,2027-01-06,2027-01-07,2027-01-24,2027-04-30,2027-05-01,2027-05-02,2027-05-03,2027-06-01,2027-06-20,2027-06-21,2027-08-15,2027-11-30,2027-12-01,2027-12-25,2027-12-26'.split(',');
  var working = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && holidays.indexOf(d.toISOString().slice(0, 10)) === -1; };
  var nextWorking = function (d) { var x = new Date(d.getTime() + DAY); while (!working(x)) x = new Date(x.getTime() + DAY); return x; };
  var wd = function (d) { return WEEKDAYS[d.getUTCDay()]; };
  var currentDeliverDayWord = 'în 1–2 zile';
  var bucharestNow = function () {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    } catch (e) {}
    var n = new Date();
    return p.year
      ? { day: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), min: (+p.hour % 24) * 60 + +p.minute }
      : { day: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), min: n.getHours() * 60 + n.getMinutes() };
  };
  function renderDates() {
    var now = bucharestNow(), today = now.day;
    var shipToday = working(today) && now.min < CUTOFF;
    var ship = shipToday ? today : nextWorking(today);
    var d1 = nextWorking(ship), d2 = nextWorking(d1);
    var deliver = d1.getUTCMonth() === d2.getUTCMonth()
      ? wd(d1) + '–' + wd(d2) + ', ' + d1.getUTCDate() + '–' + d2.getUTCDate() + ' ' + MONTHS[d2.getUTCMonth()]
      : wd(d1) + ' ' + d1.getUTCDate() + ' ' + MONTHS[d1.getUTCMonth()] + ' – ' + wd(d2) + ' ' + d2.getUTCDate() + ' ' + MONTHS[d2.getUTCMonth()];
    $$('[data-date="ship"]').forEach(function (el) { el.textContent = shipToday ? 'azi' : wd(ship); });
    $$('[data-date="deliver"]').forEach(function (el) { el.textContent = deliver; });
    var ahead = Math.round((d1.getTime() - today.getTime()) / DAY);
    currentDeliverDayWord = ahead === 1 ? 'mâine' : ahead === 2 ? 'poimâine' : wd(d1);
    $$('[data-date="deliver-day"]').forEach(function (el) { el.textContent = currentDeliverDayWord; });
  }
  renderDates();
  setInterval(renderDates, 30000);

  /* ---------- homepage: instant search across active Meta Ads products only ---------- */
  var pgrid = $('[data-pgrid]');
  if (pgrid) {
    var searchInputs = $$('[data-home-search]');
    var clearBtns = $$('[data-home-search-clear]');
    var emptyEl = $('[data-search-empty]');
    var emptyTermEl = $('[data-search-term]');
    var resetBtn = $('[data-search-reset]');
    var cards = $$('[data-pcard]', pgrid);
    cards.forEach(function (el) {
      el._normSearch = norm(el.getAttribute('data-search') || el.textContent);
    });

    var applyFilter = function (rawVal) {
      var q = norm(rawVal);
      var visibleCount = 0;
      cards.forEach(function (c) {
        var match = !q || (c._normSearch && c._normSearch.indexOf(q) !== -1);
        c.hidden = !match;
        if (match) visibleCount++;
      });
      if (emptyEl) {
        emptyEl.hidden = visibleCount > 0;
        if (emptyTermEl) emptyTermEl.textContent = String(rawVal || '').trim();
      }
    };

    var syncSearch = function (val, sourceInput) {
      searchInputs.forEach(function (inp) {
        if (inp !== sourceInput && inp.value !== val) inp.value = val;
      });
      clearBtns.forEach(function (btn) {
        btn.hidden = !String(val || '').trim();
      });
      applyFilter(val);
    };

    searchInputs.forEach(function (inp) {
      inp.addEventListener('input', function () {
        syncSearch(inp.value, inp);
      });
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var sec = $('#produse');
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    clearBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        syncSearch('', null);
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        syncSearch('', null);
      });
    }
  }

  /* ---------- policy pages: contents from the policy's own headings, the section in view marked ---------- */
  var polText = $('[data-pol-body] .rte'), polToc = $('[data-pol-toc]');
  if (polText && polToc) {
    $$('p', polText).forEach(function (p) {
      var t = (p.textContent || '').replace(/\u00a0/g, ' ').trim();
      if (!t && !p.querySelector('img, iframe')) p.classList.add('is-dup');
    });
    var polKids = Array.prototype.slice.call(polText.children).filter(function (el) { return !el.classList.contains('is-dup'); }).slice(0, 3);
    for (var di = 0; di < polKids.length; di++) {
      var dupText = (polKids[di].textContent || '').replace(/\u00a0/g, ' ').trim();
      if (polKids[di].tagName === 'P' && dupText.length < 70 && (dupText === dupText.toUpperCase() || /^www\./i.test(dupText) || /^politica de confiden/i.test(dupText))) polKids[di].classList.add('is-dup');
      else break;
    }
    var nativeHeadingCount = $$('h1, h2, h3, h4', polText).length;
    if (nativeHeadingCount < 3) {
      var skipShort = /^(Link Retur|Drepturi vizate|Descriere|Accesul|Rectificarea|Opoziția)$/i;
      Array.prototype.slice.call(polText.children).forEach(function (el) {
        if (el.tagName !== 'P' || el.classList.contains('is-dup')) return;
        var txt = (el.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
        if (txt.length >= 6 && txt.length <= 68 && /^[A-ZĂÂÎȘȚ]/.test(txt) && !/[.:;,!]$/.test(txt) && !skipShort.test(txt) && !el.querySelector('a, img, iframe')) {
          var h2 = document.createElement('h2');
          h2.textContent = txt;
          el.parentNode.replaceChild(h2, el);
        }
      });
    }
    var polLevel = ['h2', 'h1', 'h3', 'h4'].filter(function (t) { return polText.getElementsByTagName(t).length >= 2; })[0];
    var polHeads = polLevel ? $$(polLevel, polText) : [];
    if (polHeads.length >= 2) {
      var polList = $('[data-pol-toc-list]', polToc), polUsed = {};
      polHeads.forEach(function (h, i) {
        var label = (h.textContent || '').replace(/\s+/g, ' ').replace(/\s+[–-]\s+(IeftinDeTot|SuperProduse)\.ro$/i, '').trim();
        var num = /^(\d+)[.)]\s*/.exec(label);
        var id = h.id || 's-' + (label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || i);
        while (polUsed[id]) id += '-' + i;
        polUsed[id] = true;
        h.id = id;
        h.setAttribute('data-pol-top', '');
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + id;
        a.setAttribute('data-n', num ? num[1] : String(i + 1));
        a.textContent = num ? label.slice(num[0].length) : label;
        li.appendChild(a);
        polList.appendChild(li);
      });
      $('[data-pol-toc-n]', polToc).textContent = String(polHeads.length);
      polToc.hidden = false;
      var polWide = window.matchMedia('(min-width: 1024px)');
      var polSync = function () { if (polWide.matches) polToc.open = true; };
      polSync();
      if (polWide.addEventListener) polWide.addEventListener('change', polSync);
      polList.addEventListener('click', function (e) { if (e.target.closest('a') && !polWide.matches) polToc.open = false; });
      if ('IntersectionObserver' in window) {
        var polLinks = $$('a', polList);
        var polIO = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (!e.isIntersecting) return;
            polLinks.forEach(function (a) { a.setAttribute('aria-current', String(a.getAttribute('href') === '#' + e.target.id)); });
          });
        }, { rootMargin: '0px 0px -70% 0px' });
        polHeads.forEach(function (h) { polIO.observe(h); });
      }
    }
  }

  /* ---------- purchase toast (mock) ---------- */
  var toast = $('#buy-toast');
  var toastTimer = null;
  var toastsStopped = false;
  function showToast() { if (toast) toast.classList.add('is-open'); }
  function hideToast() { if (toast) toast.classList.remove('is-open'); }
  if (toast && MOCK.enabled && demo !== 'clean' && demo !== 'exit') {
    var buyers = CFG.buyers || [];
    var bi = 0;
    var nameEl = $('[data-toast-name]', toast), minsEl = $('[data-toast-mins]', toast), avEl = $('[data-toast-av]', toast), prodEl = $('[data-toast-prod]', toast);
    var tones = ['#0a0a0a', '#18181b', '#0d7c55', '#b91c1c'];
    var activeTitles = $$('[data-ad-card] .pcard-title').map(function (el) { return (el.textContent || '').trim(); }).filter(Boolean);
    var fill = function (b) {
      nameEl.textContent = b.name + ' din ' + b.city;
      minsEl.textContent = 'acum ' + randMins() + ' min';
      if (prodEl && activeTitles.length) {
        prodEl.textContent = 'a comandat ' + activeTitles[bi % activeTitles.length];
      }
      if (avEl) {
        var parts = b.name.replace('.', '').split(' ');
        avEl.textContent = (parts[0].charAt(0) + (parts[1] || '').charAt(0)).toUpperCase();
        avEl.style.background = tones[(b.name.length + b.city.length) % tones.length];
      }
    };
    var cycle = function () {
      if (toastsStopped) return;
      if (document.hidden || !buyers.length) { toastTimer = setTimeout(cycle, 3000); return; }
      fill(buyers[bi % buyers.length]);
      bi++;
      showToast();
      toastTimer = setTimeout(function () { hideToast(); toastTimer = setTimeout(cycle, MOCK.toastGapMs || 34500); }, MOCK.toastVisibleMs || 5500);
    };
    $('.toast-x', toast).addEventListener('click', function () { clearTimeout(toastTimer); hideToast(); toastTimer = setTimeout(cycle, (MOCK.toastGapMs || 34500) * 1.5); });
    if (demo === 'toast') { fill(buyers[0]); showToast(); }
    else toastTimer = setTimeout(cycle, MOCK.toastFirstDelayMs || 12000);
  }
})();
